// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__qUWGi","image":"Header_image__2_ydC","name":"Header_name__2PIIg","info":"Header_info__JGLAl","infoRow":"Header_infoRow__2pVqO"};